module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open) ? _c('fullscreen-modal', {
    attrs: {
      "close": _vm.close
    }
  }, [(_vm.videoOpen) ? _c('div', {
    staticClass: "video-modal-container"
  }, [_c('div', {
    staticClass: "video-title",
    domProps: {
      "innerHTML": _vm._s(_vm.videoOpen.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-embed"
  }, [_c('iframe', {
    attrs: {
      "width": "480",
      "height": "270",
      "src": ("//www.youtube.com/embed/" + (_vm.videoOpen.id) + "?autoplay=1"),
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "video-description",
    domProps: {
      "innerHTML": _vm._s(_vm.videoOpen.description)
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-526bce84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/video-modal.vue
// module id = 177
// module chunks = 4